import store from "../store/";

export default {
    message(text = null) {
        const localization = store.getters.localization;

        if (!localization) return;

        const lang =
            document.documentElement.lang !== ""
                ? document.documentElement.lang.split("-")[0].toLowerCase()
                : localization.default;

        if (!localization[lang])
            return "(no translation found for " + lang + ")";

        return localization[lang][text];
    },
};
